
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.8","height":"37.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"フッター　その他","fill":"#6d6c6f"}},[_c('text',{attrs:{"transform":"translate(.4 36.5)","stroke":"#6d6c6f","stroke-width":".4","font-size":"11","font-family":"HiraKakuProN-W3, Hiragino Kaku Gothic ProN"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('その他')])]),_c('path',{attrs:{"d":"M17.111 14.175a3.675 3.675 0 113.674-3.675 3.674 3.674 0 01-3.674 3.675m7.8-2.657a8.162 8.162 0 00.073-1.018 8.982 8.982 0 00-.073-1.05l2.218-1.712a.53.53 0 00.126-.672l-2.1-3.633a.516.516 0 00-.64-.231l-2.613 1.05a7.607 7.607 0 00-1.774-1.029L19.74.44a.531.531 0 00-.53-.44h-4.2a.531.531 0 00-.525.441l-.386 2.783a7.607 7.607 0 00-1.77 1.029L9.712 3.2a.516.516 0 00-.64.231l-2.1 3.633a.518.518 0 00.126.672L9.313 9.45a8.982 8.982 0 00-.073 1.05 8.161 8.161 0 00.073 1.018l-2.215 1.743a.518.518 0 00-.126.672l2.1 3.633a.527.527 0 00.64.231l2.617-1.06a7.289 7.289 0 001.774 1.04l.388 2.782a.531.531 0 00.525.441h4.2a.531.531 0 00.525-.441l.388-2.782a7.642 7.642 0 001.774-1.04l2.608 1.063a.527.527 0 00.64-.231l2.1-3.633a.53.53 0 00-.126-.672z"}})])])
          )
        }
      }
    